import { bookingComponents } from "./booking";
import { ColorComponent } from "./color/color.component";
import { communicationsComponents } from "./communications";
import { CustomToggleComponent } from "./custom-toggle/custom-toggle.component";
import { DarkModeComponent } from "./dark-mode/dark-mode.component";
import { markers } from "./markers";
import { SeatsComponent } from "./seats/seats.component";
import { serviceComponents } from "./service";
import { ServiceTagComponent } from "./service-tag/service-tag.component";
import { setupComponents } from "./setups";
import { tripComponents } from "./trips";
import { userComponents } from "./users";

export {
  ColorComponent,
  CustomToggleComponent,
  DarkModeComponent,
  SeatsComponent,
  ServiceTagComponent,
};

export const components = [
  ...bookingComponents,
  ...markers,
  ...serviceComponents,
  ...setupComponents,
  ...tripComponents,
  ...userComponents,
  ...communicationsComponents,
  ColorComponent,
  CustomToggleComponent,
  DarkModeComponent,
  SeatsComponent,
  ServiceTagComponent,
]

